export const hasAcceptedPrivatePoliciesSelector = state =>
  state.privatePolicies.accepted;
